export const getDefaultValues = (gatewayDetails) => ({
  GatewayGatewayActiveTypeID: gatewayDetails?.GatewayGatewayActiveTypeID || '',
  GatewayGatewayTypeID: gatewayDetails?.GatewayGatewayTypeID || '',
  GatewayGatewayPriceTypeID: gatewayDetails?.GatewayGatewayPriceTypeID || '',
  GatewayLabel: gatewayDetails?.GatewayLabel || '',
  GatewayLogo: gatewayDetails?.GatewayLogo || '',
  GatewayToken: gatewayDetails?.GatewayToken || '',
  GatewayClientId: gatewayDetails?.GatewayClientId || '',
  GatewayClientToken: gatewayDetails?.GatewayClientToken || '',
  GatewayCredit: gatewayDetails?.GatewayCredit || 0,
});
